import { Info } from '@mui/icons-material'
import { Typography, keyframes } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2/Grid2'
import CardPessoaLista from '../CardPessoa/CardPessoaLista'
import { useContext, useState } from 'react'
import { VisitantesContext } from '../../../../Providers/VisitantesContext/VisitantesContext'
import ModalInfoImovel from '../CardImovel/ModalInfoImovel'

const PessoasImovelList = () => {
    const { imoveis, activeCond } = useContext(VisitantesContext)
    const [openInfoImovel, setOpenInfoImovel] = useState(false)
    return (
        <Grid sx={{
            display: 'flex',
            flexDirection: 'column',
            borderRight: '1px solid white',
            width: '80%',
            height: '100%',
            padding: '3px'
        }}>
            <Grid key={`index-${Math.random()}`} gap={1} sx={{
                display: 'flex',
                flexDirection: 'row',
                width: '100%',
                height: '100%',
                flexWrap: 'wrap',
                overflowY: 'scroll',
                justifyContent: 'space-around',
                alignContent: 'flex-start',
                alignItems: 'flex-start'
            }}>
                {imoveis && imoveis.length > 0
                    ? <>{imoveis.map((imovel, index) => {
                        return (
                            <>
                                <Grid key={`imoveis-${index}`} sx={{
                                // border: '1px solid red',
                                    height: 'auto',
                                    width: '100%',
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'center',
                                    alignItems: 'stretch',
                                    marginBottom: '5px'
                                }}>
                                    {openInfoImovel &&
                                <ModalInfoImovel
                                    imovel={imovel}
                                    open={openInfoImovel}
                                    setOpen={setOpenInfoImovel}
                                />}
                                    <Grid sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        width: '130px',
                                        justifyContent: 'flex-start',
                                        alignItems: 'center',
                                        borderRadius: '5px',
                                        margin: '5px',
                                        backgroundColor: 'white',
                                        boxShadow: '0px 2px 4px 1px rgba(0, 0, 0, 0.322)',
                                        padding: '8px'
                                    }}>
                                        <Typography sx={TypographySx}>
                                            {activeCond.tipo_imovel} {imovel.unidade1}
                                        </Typography>
                                        <Typography sx={TypographySx}>
                                            {activeCond.desc_tipo_imovel} {imovel.unidade2}
                                        </Typography>
                                        <Typography sx={TypographySx}>
                                        Vagas disp./total: {imovel.vagas_disponiveis || (imovel.vagas_garagem || 0) }/{imovel.vagas_garagem || 0}
                                        </Typography>
                                        <Info onClick={() => setOpenInfoImovel(true)} sx={{
                                            ...IconSx,
                                            color: imovel.observacao && imovel.observacao != ''
                                                ? 'red'
                                                : 'black',
                                            animation: imovel.observacao && imovel.observacao != '' ? `${blinkAnimation} 1s 3` : 'none'
                                        }}
                                        />
                                    </Grid>
                                    {imovel.moradores && imovel.moradores.length > 0 &&
                                        <Grid sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            width: '80%',
                                            justifyContent: 'flex-start',
                                            alignContent: 'flex-start',
                                            alignItems: 'flex-start'
                                        }}>
                                            {imovel.moradores.map((pessoa, index) => {
                                                return <CardPessoaLista
                                                    pessoa={pessoa}
                                                    ramalImovel={imovel.ramal}
                                                    key={index}
                                                    imovelSelecionado={imovel}
                                                    tipo_licenca_cond={imovel.tipo_licenca_cond}
                                                />
                                            })}
                                        </Grid>
                                    }
                                </Grid>
                                <hr height={'1px'} width={'100%'}/>
                            </>
                        )
                    })}</>
                    : <><Typography sx={TypographySx}>
                    Nenhum morador para essa pesquisa!
                    </Typography>
                    </>
                }
            </Grid>
        </Grid>
    )
}

export default PessoasImovelList

const TypographySx = {
    color: 'black',
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '14px',
    textAlign: 'center'
}
export const IconSx = {
    color: 'black',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '45px',
    height: '20px',
    cursor: 'pointer'
}

const blinkAnimation = keyframes`
    0% {
        color: red;
    }
    33% {
        color: blue;
    }
    66% {
        color: red;
    }
    100% {
        color: red;
    }
`
